exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.swal2-title {\n  position: relative;\n  max-width: 100%;\n  margin: 20px !important;\n  padding: 0.8em 1em 0;\n  color: inherit;\n  font-size: 20px !important;\n  font-weight: 100;\n}\n", ""]);

// exports
